import React from "react";
import InvoiceGenerator from "../applicationUi/components/InvoiceGenerator";

const ViewInvoicePDFModal = ({ onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white rounded-sm shadow-xl border border-gray-200 p-6 w-full max-w-6xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-200">
          <div>
            <h2 className="text-xl font-semibold text-gray-900 tracking-tight">
              Invoice Details
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              View and manage invoice information
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-sm hover:bg-gray-100">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="mt-4">
          <InvoiceGenerator />
        </div>
      </div>
    </div>
  );
};

export default ViewInvoicePDFModal;
